(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      const els = document.querySelectorAll('[data-countdown-end]');
      if (!els.length) return;
      const now = Date.now();
      els.forEach(el => {
        const target = new Date(el.dataset.countdownEnd).getTime();
        if (isNaN(target)) { el.textContent = ''; return; }
        const diff = target - now;
        if (diff <= 0) { el.textContent = el.dataset.endedText || 'Ended'; return; }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        el.textContent = pad(h) + 'H ' + pad(m) + 'M ' + pad(s) + 'S';
      });
    }

    if (!window.__tckCountdownInterval) {
      window.__tckCountdownInterval = setInterval(tick, 1000);
      document.addEventListener('DOMContentLoaded', tick);
      tick();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* rebuild 1778545864.8485389 */
  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.bindOpeners();
        this.addEventListener('click', e => {
          if (e.target.closest('[data-cart-close]')) this.close();
          if (e.target.closest('[data-cart-qty]')) this.onQty(e);
          if (e.target.closest('[data-cart-remove]')) this.onRemove(e);
        });
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });
        document.addEventListener('submit', e => this.onFormSubmit(e), true);
      }

      bindOpeners() {
        document.querySelectorAll('[data-cart-open]').forEach(el => {
          el.addEventListener('click', e => {
            e.preventDefault();
            this.open();
          });
        });
      }

      open() {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tck-cart-open');
        const panel = this.querySelector('[role="dialog"]');
        if (panel) panel.focus();
      }

      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tck-cart-open');
      }

      async onFormSubmit(e) {
        const form = e.target.closest('[data-cart-form]');
        if (!form) return;
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Adding…'; }
        try {
          const formData = new FormData(form);
          const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error('Add failed');
          await this.refresh();
          this.open();
        } catch (err) {
          console.error(err);
        } finally {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.label || 'Add to cart'; }
        }
      }

      async onQty(e) {
        const btn = e.target.closest('[data-cart-qty]');
        const line = parseInt(btn.dataset.line, 10);
        const dir = btn.dataset.cartQty;
        const valEl = this.querySelector(`[data-cart-line="${line}"] [data-qty-value]`);
        if (!valEl) return;
        const current = parseInt(valEl.textContent, 10) || 0;
        const next = dir === 'inc' ? current + 1 : Math.max(0, current - 1);
        await this.changeLine(line, next);
      }

      async onRemove(e) {
        const btn = e.target.closest('[data-cart-remove]');
        const line = parseInt(btn.dataset.line, 10);
        await this.changeLine(line, 0);
      }

      async changeLine(line, quantity) {
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line, quantity })
          });
          if (!res.ok) throw new Error('Change failed');
          await this.refresh();
        } catch (err) { console.error(err); }
      }

      async refresh() {
        try {
          const res = await fetch('/?sections=cart-drawer');
          const data = await res.json();
          if (!data['cart-drawer']) return;
          const tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          const newDrawer = tmp.querySelector('cart-drawer');
          if (!newDrawer) return;
          const wasOpen = this.classList.contains('is-open');
          // Replace OUR _panel and _overlay (which live in body) with the fresh ones
          // from the re-rendered section. Then re-bind references.
          this.innerHTML = newDrawer.innerHTML;
          this.className = newDrawer.className + (wasOpen ? ' is-open' : '');
          this.dispatchCartUpdated();
        } catch (err) { console.error(err); }
      }

      async dispatchCartUpdated() {
        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        } catch (err) {}
      }
    }

    customElements.define('cart-drawer', CartDrawer);

    document.addEventListener('cart:updated', e => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        const n = e.detail.item_count;
        if (el.tagName === 'SPAN' || el.classList.contains('tck-cart-drawer__count')) {
          el.textContent = `(${n})`;
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mobile-nav')) {
    class MobileNav extends HTMLElement {
      connectedCallback() {
        document.querySelectorAll('[data-mobile-nav-open]').forEach(el => {
          el.addEventListener('click', e => { e.preventDefault(); this.open(el); });
        });
        this.addEventListener('click', e => {
          if (e.target.closest('[data-mobile-nav-close]')) this.close();
        });
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });
      }
      open(trigger) {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tck-mobile-nav-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        this.openTrigger = trigger;
        const panel = this.querySelector('[role="dialog"]');
        if (panel) panel.focus();
      }
      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tck-mobile-nav-open');
        if (this.openTrigger) {
          this.openTrigger.setAttribute('aria-expanded', 'false');
          this.openTrigger.focus();
        }
      }
    }
    customElements.define('mobile-nav', MobileNav);
  }

  /* ---- Search overlay ----
     Predictive search via /search/suggest.json (Shopify built-in).
     Triggered by [data-search-open]. Closes on backdrop click, Esc,
     or close button. Form submit goes to /search?q=... as fallback. */
  if (!customElements.get('search-overlay')) {
    class SearchOverlay extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-search-input]');
        this.results = this.querySelector('[data-search-results]');
        this.debounceTimer = null;
        this.lastQuery = '';

        // Open triggers
        document.querySelectorAll('[data-search-open]').forEach(el => {
          el.addEventListener('click', e => { e.preventDefault(); this.open(el); });
        });

        // Close triggers (backdrop, close button)
        this.querySelectorAll('[data-search-close]').forEach(el => {
          el.addEventListener('click', () => this.close());
        });

        // Esc closes
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
        });

        // Live search on input (200ms debounce)
        if (this.input) {
          this.input.addEventListener('input', () => {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => this.search(), 200);
          });
        }
      }

      open(trigger) {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tck-search-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        this.openTrigger = trigger;
        // Focus input after slide-in animation starts
        setTimeout(() => { if (this.input) this.input.focus(); }, 80);
      }

      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('tck-search-open');
        if (this.input) this.input.value = '';
        this.lastQuery = '';
        this.renderEmpty();
        if (this.openTrigger) {
          this.openTrigger.setAttribute('aria-expanded', 'false');
          this.openTrigger.focus();
        }
      }

      renderEmpty() {
        if (this.results) {
          this.results.innerHTML = '<p class="tck-search-overlay__hint tck-meta">Start typing to find prints, decks, and notes…</p>';
        }
      }

      async search() {
        const q = (this.input && this.input.value || '').trim();
        if (q.length < 2) { this.renderEmpty(); return; }
        if (q === this.lastQuery) return;
        this.lastQuery = q;

        this.results.innerHTML = '<p class="tck-search-overlay__loading tck-meta">Searching…</p>';

        try {
          const url = '/search/suggest.json?q=' + encodeURIComponent(q)
            + '&resources[type]=product'
            + '&resources[limit]=8'
            + '&resources[options][unavailable_products]=hide'
            + '&resources[options][fields]=title,product_type,variants.title,vendor';
          const res = await fetch(url);
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          this.renderResults(products, q);
        } catch (err) {
          if (this.results) {
            this.results.innerHTML = '<p class="tck-search-overlay__hint tck-meta">Search unavailable. Try again in a moment.</p>';
          }
        }
      }

      escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, c => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
      }

      renderResults(products, query) {
        if (!products.length) {
          this.results.innerHTML = '<p class="tck-search-overlay__hint tck-meta">No matches for "' + this.escapeHtml(query) + '".</p>';
          return;
        }

        const cards = products.map(p => {
          const img = p.image
            ? '<img src="' + this.escapeHtml(p.image) + '" alt="" loading="lazy">'
            : '';
          const imgClass = p.image
            ? 'tck-search-result__image'
            : 'tck-search-result__image tck-search-result__image--placeholder';
          return '<a href="' + this.escapeHtml(p.url) + '" class="tck-search-result">'
            + '<div class="' + imgClass + '">' + img + '</div>'
            + '<div class="tck-search-result__body">'
            + '<p class="tck-search-result__title">' + this.escapeHtml(p.title) + '</p>'
            + (p.price ? '<p class="tck-search-result__price">' + this.escapeHtml(p.price) + '</p>' : '')
            + '</div></a>';
        }).join('');

        this.results.innerHTML = '<div class="tck-search-overlay__list">' + cards + '</div>'
          + '<a href="/search?q=' + encodeURIComponent(query) + '" class="tck-search-overlay__view-all">View all results for "' + this.escapeHtml(query) + '" →</a>';
      }
    }
    customElements.define('search-overlay', SearchOverlay);
  }

  } catch(e) { console.error(e); }
})();
})();
